import React from 'react';
import { Button } from './Button';
import { ChevronDownIcon } from 'lucide-react';
const DisclosureRow = ({
  onClick,
  isOpen,
  count
}) => {
  return <button onClick={onClick} className="w-full flex items-center justify-center py-2 text-sm text-link dark:text-dark-link hover:text-link-hover dark:hover:text-dark-link-hover focus:outline-none" data-id="element-87">
      <span data-id="element-88">{isOpen ? 'Show less' : 'Show all'}</span>
      <ChevronDownIcon className={`ml-1 w-4 h-4 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-89" />
    </button>;
};
const Sidebar = () => {
  const categories = [{
    id: 'career-coaching',
    name: 'Career Coaching',
    active: true
  }, {
    id: 'marketing-design',
    name: 'Marketing & Design',
    active: false
  }, {
    id: 'coding-app-dev',
    name: 'Coding & App Development',
    active: false
  }];
  const scrollToSection = (id: string, e: React.MouseEvent) => {
    e.preventDefault();
    console.log(`Attempting to scroll to section with ID: ${id}`);
    // First try: Get element directly by ID
    const element = document.getElementById(id);
    if (element) {
      console.log(`Found element by ID: ${id}`);
      element.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // Second try: Find by title text in h2
      const categoryName = categories.find(cat => cat.id === id)?.name;
      if (categoryName) {
        console.log(`Looking for h2 with text: ${categoryName}`);
        // Find h2 elements
        const h2Elements = document.querySelectorAll('h2');
        let targetSection = null;
        // Check each h2 element to find one with matching text
        h2Elements.forEach(h2 => {
          if (h2.textContent === categoryName) {
            console.log(`Found h2 with matching text: ${categoryName}`);
            // Get the closest parent div that might be the section
            targetSection = h2.closest('div[id]');
          }
        });
        if (targetSection) {
          console.log(`Found target section with ID: ${targetSection.id}`);
          targetSection.scrollIntoView({
            behavior: 'smooth'
          });
        } else {
          console.log(`Could not find section with title: ${categoryName}`);
          // Third try: Find any div that might contain the category content
          const allDivs = document.querySelectorAll('div');
          let foundDiv = null;
          allDivs.forEach(div => {
            if (div.textContent?.includes(categoryName)) {
              const h2InDiv = div.querySelector('h2');
              if (h2InDiv && h2InDiv.textContent === categoryName) {
                foundDiv = div;
              }
            }
          });
          if (foundDiv) {
            console.log(`Found div containing the category: ${categoryName}`);
            foundDiv.scrollIntoView({
              behavior: 'smooth'
            });
          } else {
            console.log(`Failed to find any element containing: ${categoryName}`);
          }
        }
      } else {
        console.log(`No category found with ID: ${id}`);
      }
    }
  };
  return <div className="hidden md:block w-full md:w-72 md:min-w-72 p-4 md:min-h-[calc(100vh-60px)]" data-id="element-90">
      <div className="bg-white dark:bg-dark-background bg-opacity-80 dark:bg-opacity-80 rounded-lg overflow-hidden mb-4 border border-gray-200 dark:border-dark-border" data-id="element-91">
        <ul className="divide-y divide-gray-100 dark:divide-dark-border" data-id="element-92">
          {categories.map(category => <li key={category.id} data-id="element-93">
              <a href={`#${category.id}`} onClick={e => scrollToSection(category.id, e)} className={`block px-4 py-3 transition-colors ${category.active ? 'text-text dark:text-dark-text hover:bg-[#F8F8F8] dark:hover:bg-dark-background-neutral-soft' : 'text-text dark:text-dark-text hover:bg-[#F8F8F8] dark:hover:bg-dark-background-neutral-soft'}`} data-id="element-94">
                {category.name}
              </a>
            </li>)}
        </ul>
      </div>
      <div className="rounded-lg p-4 text-center border border-gray-200 dark:border-dark-border bg-white dark:bg-dark-background bg-opacity-80 dark:bg-opacity-80" data-id="element-95">
        <div className="flex justify-center mb-2" data-id="element-96">
          <div className="w-12 h-12 rounded-full flex items-center justify-center bg-[#CFE3E6] dark:bg-[#CFE3E6]" data-id="element-97">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ufLY3y4gAaF9FRZNSd4q9g/Signal_AI.svg" alt="Signal AI" className="w-6 h-6" data-id="element-98" />
          </div>
        </div>
        <h3 className="text-sm font-medium mb-2 dark:text-dark-text" data-id="element-99">
          Want to list your AI tool?
        </h3>
        <a href="https://forms.office.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbR6fDoxh-HzVGmyoQOI03pZNUQTRLTlhJSkk2WVZZUjNVMDNNWENQQzZUNi4u&route=shorturl" target="_blank" data-id="element-100">
          <Button type="secondary" size="small" className="font-medium !font-normal dark:text-[#71B7FB] dark:border-[#71B7FB] dark:bg-dark-background dark:hover:bg-[rgb(55_143_233_/_0.25)]" style={{
          fontWeight: 500
        }} data-id="element-101">
            Become a partner
          </Button>
        </a>
      </div>
    </div>;
};
export default Sidebar;